module.exports = __webpack_public_path__ + "img/C05TechCenturionChampion_ua.1fad7005.webp";